import React, { useState } from "react";
import { Box, Button, Drawer, TextField, Typography } from "@mui/material";
import updateSheetValues from "../update-google-sheet";
import { useNavigate } from "react-router-dom";

function QuoteAdditionalServices({
  address,
  bucket,
  script_id,
  driver,
  updateCache,
}) {
  const [open, setOpen] = useState(false);
  const [mulchingYards, setMulchingYards] = useState("");
  const [weedingHours, setWeedingHours] = useState("");
  const [bushTrimmingHours, setBushTrimmingHours] = useState("");
  const [fertilizationBags, setFertilizationBags] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const navigate = useNavigate();

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setSuccessMessage("");
  };

  const handleSubmit = async () => {
    setSubmitting(true);
    const baseUrl =
      "https://script.google.com/macros/s/AKfycbwz6yaK87LoJE4CWmoodmf-hdEic53ceV6E_sTDUuY1zzvVwseCc3Df9j0OtnrmafuoYw/exec"; // Replace with your actual URL
    const queryParams = new URLSearchParams({
      address,
      mulchingYards,
      weedingHours,
      bushTrimmingHours,
      fertilizationBags,
    }).toString();

    try {
      const response = await fetch(`${baseUrl}?${queryParams}`, {
        method: "GET",
      });

      const data = await response.json();
      console.log("Response:", data);
      if (data.status === "success") {
        setSuccessMessage("Quote submitted successfully!");
        if (driver && script_id) {
          updateCache(address);
          updateSheetValues(address, "", driver, script_id);
        }

        setTimeout(() => {
          handleClose();
          //   navigate("/");
        }, 1000);
      } else {
        alert("Failed to submit quote. Try again.");
      }
    } catch (error) {
      console.error("Error submitting quote:", error);
      alert("An error occurred.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          mt: 2,
          paddingBottom: 1,
        }}
      >
        <Button
          variant="contained"
          color="primary"
          onClick={handleOpen}
          sx={{ width: "88%", fontWeight: "Bold", fontFamily: "Poppins" }}
        >
          Quote Landscaping Services
        </Button>
        <Typography variant="h6" fontWeight="bold" fontFamily="Poppins" mt={1}>
          {bucket}
        </Typography>
      </Box>
      <Drawer anchor="bottom" open={open} onClose={handleClose}>
        <Box
          sx={{
            width: "90%",
            height: "100vh",
            bgcolor: "white",
            paddingTop: 3,
            // display: "flex",
            justifyContent: "center", // Centers horizontally
            // alignItems: "center",      // Centers vertically
            margin: "auto", // Ensures proper centering
          }}
        >
          <Typography
            variant="h6"
            fontWeight="bold"
            fontFamily="Poppins"
            mb={1}
          >
            Quote Landscaping Services
          </Typography>
          <Typography
            variant="h6"
            fontWeight="bold"
            fontFamily="Poppins"
            mt={1}
          >
            {bucket}
          </Typography>

          {successMessage && (
            <Typography
              variant="body1"
              color="success.main"
              fontFamily="Poppins"
              mb={2}
            >
              {successMessage}
            </Typography>
          )}

          {submitting ? (
            <Typography
              variant="body1"
              color="primary"
              fontFamily="Poppins"
              mb={2}
            >
              Submitting...
            </Typography>
          ) : (
            <>
              {/* Input Fields for Each Service */}
              <TextField
                fullWidth
                label="Mulching (Yards)"
                variant="outlined"
                margin="normal"
                type="number"
                value={mulchingYards}
                onChange={(e) => setMulchingYards(e.target.value)}
              />

              <TextField
                fullWidth
                label="Weeding (Hours)"
                variant="outlined"
                margin="normal"
                type="number"
                value={weedingHours}
                onChange={(e) => setWeedingHours(e.target.value)}
              />

              <TextField
                fullWidth
                label="Bush Trimming (Hours)"
                variant="outlined"
                margin="normal"
                type="number"
                value={bushTrimmingHours}
                onChange={(e) => setBushTrimmingHours(e.target.value)}
              />

              <TextField
                fullWidth
                label="Fertilization (Bags)"
                variant="outlined"
                margin="normal"
                type="number"
                value={fertilizationBags}
                onChange={(e) => setFertilizationBags(e.target.value)}
              />

              {/* Submit Button */}
              <Button
                variant="contained"
                color="success"
                onClick={handleSubmit}
                sx={{ mt: 3 }}
                fullWidth
              >
                Submit Quote
              </Button>
            </>
          )}

          {/* Cancel Button */}
          <Button
            variant="outlined"
            color="error"
            onClick={handleClose}
            sx={{ mt: 1 }}
            fullWidth
          >
            Cancel
          </Button>
        </Box>
      </Drawer>
    </Box>
  );
}

export default QuoteAdditionalServices;
